import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

export interface TrackerFilter {
  group: string;
  accessType?: string;
}

export interface TrackerQuery {
  itemId: string;
  startTime: string;
  endTime: string;
  requests: TrackerFilter[];
}

export interface TrackerLog extends Record<string, unknown> {
  message?: string;
  operation?: string;
  loggroup?: string;
  timestamp?: string;
  requestid?: string;
  country?: string;
}

export interface TrackerResponse {
  status: string;
  queryId?: string;
  data?: TrackerLog[];
}

export interface TrackerDates {
  startTime?: string;
  endTime?: string;
}

@Injectable({ providedIn: 'root' })
export class TrackerService {
  private readonly http = inject(HttpClient);

  queryDatabase(payload: TrackerQuery, production: boolean): Observable<TrackerResponse> {
    return this.http.post<TrackerResponse>(`${this.baseUrl(production)}/queryDB`, payload);
  }

  queryResult(queryId: string, production: boolean): Observable<TrackerResponse> {
    return this.http.get<TrackerResponse>(
      `${this.baseUrl(production)}/result/${encodeURIComponent(queryId)}`,
    );
  }

  queryDates(itemId: string, production: boolean): Observable<TrackerDates> {
    return this.http.get<TrackerDates>(`${this.baseUrl(production)}/queryDates`, {
      params: new HttpParams().set('itemId', itemId),
    });
  }

  getDeliveryOptionsLog(requestId: string, production: boolean): Observable<unknown> {
    return this.http.get(`${this.baseUrl(production)}/getDeliveryOptionsLog`, {
      params: new HttpParams().set('requestId', requestId),
    });
  }

  private baseUrl(production: boolean): string {
    return production ? environment.prodTrackerUrl : environment.testTrackerUrl;
  }
}